import React from 'react';
import { Amount, formatDate, renderAmount } from '../../..';
import { mdiCheckCircle, mdiCloseCircle } from '@mdi/js';
import * as S from './claim-timeline.styles';
import * as RowS from './timeline-row-components.styles';

export const TextRow = React.memo<{
    label?: string;
    value: string | number | React.ReactElement | undefined;
    truncate?: boolean;
    pre?: boolean;
}>(({ label, value, truncate, pre }) => {
    if (value === null || value === undefined) {
        return null;
    }

    const content = pre ? <pre>{value}</pre> : value;

    return (
        <S.ExpandTR>
            {label && <S.ExpandTH>{label}</S.ExpandTH>}
            <S.ExpandTD title={value.toString()}>
                {truncate ? <RowS.TruncatedValue>{content}</RowS.TruncatedValue> : content}
            </S.ExpandTD>
        </S.ExpandTR>
    );
});

export const DateRow = React.memo<{
    label?: string;
    value: string | undefined;
    shortDate?: boolean;
    timezone?: boolean;
}>(({ label, value, shortDate = false, timezone = false }) => {
    if (!value) {
        return null;
    }

    const date = shortDate
        ? formatDate(value, `MMM dd, yyyy`)
        : formatDate(value, `MMM dd, yyyy ${timezone ? 'hh:mm a Z' : 'hh:mm a'}`);

    return (
        <S.ExpandTR>
            {label && <S.ExpandTH>{label}</S.ExpandTH>}
            <S.ExpandTD>{date}</S.ExpandTD>
        </S.ExpandTR>
    );
});

export const AmountRow = React.memo<{
    label?: string;
    value: Amount | undefined;
}>(({ label, value }) => {
    if (!value) {
        return null;
    }

    return (
        <S.ExpandTR>
            {label && <S.ExpandTH>{label}</S.ExpandTH>}
            <S.ExpandTD>{renderAmount(value)}</S.ExpandTD>
        </S.ExpandTR>
    );
});

export const ElementRow = React.memo<{
    label?: string;
    children: React.ReactElement | React.ReactNode;
}>(({ label, children }) => {
    return (
        <S.ExpandTR>
            {label && <S.ExpandTH>{label}</S.ExpandTH>}
            <S.ExpandTD>{children}</S.ExpandTD>
        </S.ExpandTR>
    );
});

export const BooleanRow = React.memo<{
    label?: string;
    value: boolean | undefined;
}>(({ label, value }) => {
    if (value === undefined) {
        return null;
    }

    const result = value ? (
        <RowS.CheckIcon path={mdiCheckCircle} size={0.75} />
    ) : (
        <RowS.CrossIcon path={mdiCloseCircle} size={0.75} />
    );

    return (
        <S.ExpandTR>
            {label && <S.ExpandTH>{label}</S.ExpandTH>}
            <S.ExpandTD>{result}</S.ExpandTD>
        </S.ExpandTR>
    );
});

export const HeadingRow = React.memo<{ text: string }>(({ text }) => {
    return (
        <S.ExpandTR>
            <S.ExpandTD colSpan={2}>
                <RowS.BoxHeading>{text}</RowS.BoxHeading>
            </S.ExpandTD>
        </S.ExpandTR>
    );
});
